import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AddNotes from './AddNotes';
import NotesTable from './NotesTable';
import { Divider } from '@mui/material';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Notes = () => {
    const access = JSON.parse(localStorage.getItem('detailObject')) || {};
    const role = localStorage.getItem('role') || '';
    const accessToContent = access?.accessToContent || [];
    // Initialize value based on access permissions
    const [value, setValue] = React.useState(() => {
        if (role == 'Admin') return 0;
        if (accessToContent?.includes("Notes")) return 0;
        if (accessToContent?.includes("Add Notes")) return 1;
        return 0;
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant='h3' mb={3}>Manage Notes</Typography>
            <Divider />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="notes tabs" sx={{ width: '100%' }}>
                    {(role === 'Admin' || accessToContent.includes('Notes')) && (
                        <Tab value={0} label="All Notes" sx={{ width: '100%' }} {...a11yProps(0)} />
                    )}
                    {(role === 'Admin' || accessToContent.includes('Add Notes')) && (
                        <Tab value={1} label="Add Notes" sx={{ width: '100%' }} {...a11yProps(1)} />
                    )}
                </Tabs>
            </Box>
            {(role === 'Admin' || accessToContent.includes('Notes')) && (
                <TabPanel value={value} index={0}>
                    <NotesTable />
                </TabPanel>
            )} {(role === 'Admin' || accessToContent.includes('Add Notes')) && (
                <TabPanel value={value} index={1}>
                    <AddNotes />
                </TabPanel>
            )}
        </Box>
    );
}

export default Notes;
